import React from "react";
import { IBrandTeasersProps } from "./BrandTeasersProps";
import IBrand from "../../../@types/IBrand";
import {
  BrandTeaserContainer,
  Description,
  Title,
  BrandCards,
  BrandCardsItem,
} from "./BrandTeasersHelpers";
import SubTitle from "../../global/SubTitle/SubTitle";
import Brand from "./Brand/Brand";

const BrandTeasers: React.FC<IBrandTeasersProps> = (props) => {
  return (
    <BrandTeaserContainer>
      <SubTitle id={"brand-teaser-subtitle"}>{props.field_subtitle}</SubTitle>
      <Title id={"brand-teaser-title"}>{props.field_title}</Title>
      <Description {...props}></Description>
      <BrandCards>
        {props.brands.map((brand: IBrand, index: number) => {
          return (
            <BrandCardsItem key={`brand-${index}`}>
              <Brand {...brand} />
            </BrandCardsItem>
          );
        })}
      </BrandCards>
    </BrandTeaserContainer>
  );
};

export default BrandTeasers;
